var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{directives:[{name:"translate",rawName:"v-translate"}]},[_vm._v("\n    Your referral list is empty. Start referring today!\n  ")]),_c('div',{staticClass:"file is-centered people"},[_c('referrals-people-icon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }